export const API_TIMEOUT_MS = 30_000;

export const API_FAILURE = Object.freeze({
    AUTHENTICATION: 'authentication',
    TIMEOUT: 'timeout',
    NETWORK: 'network',
    HTTP: 'http'
});

export const classifyApiFailure = (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) return API_FAILURE.AUTHENTICATION;
    if (error?.code === 'ECONNABORTED') return API_FAILURE.TIMEOUT;
    if (!error?.response) return API_FAILURE.NETWORK;
    return API_FAILURE.HTTP;
};

// Phase 1 intentionally preserves the existing no-retry behavior. In particular,
// device commands and other non-idempotent requests must never be replayed silently.
export const shouldRetryRequest = () => false;
